module.exports = __webpack_public_path__ + "media/images/icons/country_flags/nz-64b16b7eb8b8e423bcabb80c594018ad.svg";